import { render } from "./AddNewLang.vue?vue&type=template&id=3987524e&scoped=true"
import script from "./AddNewLang.vue?vue&type=script&lang=ts"
export * from "./AddNewLang.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3987524e"

export default script